import React, { useCallback } from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';

import { FieldHint, Input } from '@atlas/ui';

import Field from '../../Field';

import VerifyBlock from './VerifyBlock';

const EmailWithVerification = ({ field, onBlur, onChange, onFocus }) => {
  const {
    active,
    autocomplete,
    autofocus,
    className,
    disabled,
    errors,
    hint,
    isModifiable = true,
    label,
    name,
    placeholder,
    touched,
    uiTitleClassName,
    value,
  } = field;
  const inputValue = value === null ? '' : value;
  const changeHandler = useCallback(event => onChange(event.target.value), [onChange]);
  const error = touched && errors[0];
  const success = touched && !error;
  const isDisabled = disabled || !isModifiable;

  return (
    <div
      className={classNames('email-with-verification', {
        'is-verified': isDisabled && !!hint,
      })}
    >
      <Field options={field}>
        <Input
          active={active}
          autoComplete={autocomplete}
          autoFocus={autofocus}
          className={className}
          disabled={isDisabled}
          error={error}
          label={label}
          name={name}
          onBlur={onBlur}
          onChange={changeHandler}
          onFocus={onFocus}
          placeholder={placeholder}
          success={success}
          touched={touched}
          uiTitleClassName={uiTitleClassName}
          value={inputValue}
        />
        <FieldHint hint={hint} />
      </Field>
      <VerifyBlock />
    </div>
  );
};

EmailWithVerification.propTypes = {
  field: PropTypes.shape({
    active: PropTypes.bool,
    autocomplete: PropTypes.string,
    autofocus: PropTypes.bool,
    className: PropTypes.string,
    disabled: PropTypes.bool,
    errors: PropTypes.arrayOf(PropTypes.object),
    hint: PropTypes.string,
    isModifiable: PropTypes.bool,
    label: PropTypes.string,
    name: PropTypes.string,
    placeholder: PropTypes.string,
    touched: PropTypes.bool,
    uiTitleClassName: PropTypes.string,
    value: PropTypes.string,
  }).isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  onFocus: PropTypes.func.isRequired,
};

export default EmailWithVerification;
